import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    SetCart,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";

replaceInChain(chain, SetCart, props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        return false;
    }

    props.cart = cart;
});
